<template>
  <NkoRekapUploadForm mode="Upload File" module="Nilai Kinerja Organisasi"> </NkoRekapUploadForm>
</template>

<script>
import NkoRekapUploadForm from './form-upload-nko';

const NkoRekapUpload = {
  name: 'NkoRekapUpload',
  components: { NkoRekapUploadForm },
};

export default NkoRekapUpload;
</script>
